import { render, staticRenderFns } from "./DVIR.vue?vue&type=template&id=50295c59&scoped=true&"
import script from "./DVIR.vue?vue&type=script&lang=js&"
export * from "./DVIR.vue?vue&type=script&lang=js&"
import style0 from "./DVIR.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DVIR.vue?vue&type=style&index=1&id=50295c59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50295c59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSelect,VTab,VTabs})
